<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="h3 mb-0">Shiptments</h2>
      <button class="btn btn-success" @click="showNewShipmentLayer = true">Add</button>
    </div>
    <div v-if="shipments === null" class="alert alert-secondary font-italic" role="alert">
      Loading...
    </div>
    <div v-else>
      <div v-if="shipments.length > 0">
        <div v-for="(shipment, index) in shipments" :key="shipment.id" class="list-group">
          <div class="list-group-item list-group-item-action mb-2">
            <div class=" d-flex justify-content-between align-items-center">
              <div>Shipment #{{ index + 1 }}</div>
              <div class="flex-grow-1 text-right">
                <span class="mr-3">{{ shipment.shipment.item.weightInKG.toString().replace('.', ',') }} kg</span>
              </div>
              <div v-if="shipment.status === 'success'" style="width: 200px; text-align: right">
                <button @click="openShipmentLabel(shipment.labelUrl)" class="btn btn-success ">
                  Print
                </button>
              </div>
              <div v-else-if="shipment.status === 'error'" style="width: 200px; text-align: right">
                <button disabled class="btn btn-outline-danger">
                  Error
                </button>
              </div>
              <div v-else-if="shipment.status === 'pending'" style="width: 200px; text-align: right">
                <button disabled class="btn btn-outline-primary">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Creating...
                </button>
              </div>
              <div v-else style="width: 200px; text-align: right">
                <button disabled class="btn btn-outline-primary">
                  Undefined
                </button>
              </div>
            </div>
            <small v-if="shipment.error" class="text-danger">{{ shipment.error.statusMessage }}</small>
          </div>
        </div>
      </div>
      <div v-else class="alert alert-info" role="alert">No Shipments founds</div>
    </div>
    <Layer v-if="showNewShipmentLayer" @close="showNewShipmentLayer = false" title="New Shipment">
      <form
        class="p-3"
        @submit.prevent="
          createParcel()
          showNewShipmentLayer = false
        "
      >
        <div class="input-group pb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-packageWeight">Weight</span>
          </div>
          <input
            v-model="weightInKG"
            type="number"
            id="replyNumber"
            data-bind="value:replyNumber"
            min="0"
            step=".1"
            class="form-control"
            placeholder="KG"
            aria-describedby="basic-packageWeight"
            autofocus
          />
        </div>
        <div style="text-align: right">
          <button style="text-align: center" type="submit" :disabled="!weightInKG.length" class="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
    </Layer>
  </div>
</template>

<script>
import Layer from '@/shared/Layer'
import { db, fb } from '@/shared/firebase'

export default {
  components: { Layer },
  props: ['orderId', 'materialShipmentId', 'contactPerson', 'receiver'],
  data() {
    return {
      shipments: null,
      shipmentsSubscription: null,
      showNewShipmentLayer: false,
      weightInKG: ''
    }
  },
  created() {
    let ref = db.collection('shipments')
    if (this.orderId) {
      ref = ref.where('orderId', '==', this.orderId)
    } else if (this.materialShipmentId) {
      ref = ref.where('materialShipmentId', '==', this.materialShipmentId)
    }
    this.shipmentsSubscription = ref.onSnapshot(snapshot => {
      const shipments = snapshot.docs.map(doc => {
        return { ...doc.data(), id: doc.id }
      })
      this.shipments = _.orderBy(shipments, 'timestamp.server')
    })
  },
  beforeDestroy() {
    this.shipmentsSubscription()
  },
  methods: {
    openShipmentLabel(url) {
      window.open(url, '_blank')
    },
    async createParcel() {
      const data = {
        shipment: {
          contactPerson: this.contactPerson || '',
          date: new Date(),
          item: {
            weightInKG: parseFloat(this.weightInKG)
          },
          receiver: this.receiver
        },
        status: 'pending',
        timestamp: {
          local: new Date(),
          server: fb.firestore.FieldValue.serverTimestamp()
        }
      }
      if (this.orderId) data.orderId = this.orderId
      if (this.materialShipmentId) data.materialShipmentId = this.materialShipmentId

      await db.collection(`shipments`).add(data)

      this.weightInKG = ''
    }
  }
}
</script>
